/* eslint-disable react/prop-types, no-unused-vars */

import { Form, Select, Input } from 'antd';

const OPERATORS = [
    'Equals', 'Not Equals', 'Contains', 'Not Contains',
    'Starts With', 'Ends With', 'Greater Than', 'Less Than',
    'Greater Than Or Equal', 'Less Than Or Equal', 'Is Empty', 'Is Not Empty',
];

const FilterRowsForm = ({ config, columns, onChange }) => (
    <Form layout="vertical" initialValues={config} onValuesChange={(_, values) => onChange(values)}>
        <Form.Item label="Column" name="column" rules={[{ required: true }]}>
            <Select placeholder="Select column" options={columns.map(c => ({ label: c, value: c }))} />
        </Form.Item>
        <Form.Item label="Operator" name="operator" rules={[{ required: true }]} initialValue="Equals">
            <Select options={OPERATORS.map(o => ({ label: o, value: o }))} />
        </Form.Item>
        <Form.Item label="Value" name="value">
            <Input placeholder="Enter filter value" />
        </Form.Item>
    </Form>
);

export default FilterRowsForm;
